var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export default (function (smarttags) {
    if (!smarttags || !Array.isArray(smarttags)) {
        throw new TypeError('Smarttags must be array');
    }
    if (!smarttags.length) {
        return [];
    }
    var normalizedSmarttags = [];
    smarttags.forEach(function (_a) {
        var key = _a.key, title = _a.title, values = _a.values;
        if (!key || !values || !values.length) {
            return;
        }
        var normalValues = values
            .map(function (_a) {
            var valueKey = _a.key, valueTitle = _a.title;
            if (!valueKey) {
                return null;
            }
            return __assign({ key: valueKey }, (valueTitle ? { title: valueTitle } : {}));
        })
            .filter(function (a) { return a; });
        if (!normalValues.length) {
            return;
        }
        // pohladame prvok pola
        var existingKeyIndex = normalizedSmarttags.findIndex(function (_a) {
            var k = _a.key;
            return key === k;
        });
        if (existingKeyIndex >= 0) {
            // prechadzame values a pridame len tie co nie su este v poli
            normalValues.forEach(function (value) {
                // ak neexistuje hodnota, pushneme, inak neriesime nic
                if (!normalizedSmarttags[existingKeyIndex].values.find(function (_a) {
                    var existingValueKey = _a.key;
                    return existingValueKey === value.key;
                })) {
                    normalizedSmarttags[existingKeyIndex].values.push(value);
                }
            });
        }
        else {
            // pridame cely smarttag
            normalizedSmarttags.push(__assign({ key: key, values: normalValues }, (title ? { title: title } : {})));
        }
    });
    return normalizedSmarttags;
});
